import { Alert } from '@chronosphereio/chrono-ui';
import { useNavigate } from 'react-router-dom';
import { POST_LOGIN_REDIRECT_URL_PARAM } from '@chronosphereio/core';
import { LogoPane } from '../components';
import { AlertButton } from '@/chrono-ui-todos';
import { AuthRoutes } from '@/model/Routes';

/**
 * View that the user is redirected to after a successful logout.
 */
export function LogoutCallback() {
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const goToLogin = () => {
    const navigateParams = new URLSearchParams();
    const redirectParam = params.get(POST_LOGIN_REDIRECT_URL_PARAM);
    if (redirectParam !== null) {
      navigateParams.set(POST_LOGIN_REDIRECT_URL_PARAM, redirectParam);
    }

    navigate({ pathname: AuthRoutes.LOGIN, search: navigateParams.toString() });
  };

  const message =
    params.get('reason') === 'timeout'
      ? 'Your session has timed out. Please login again.'
      : 'You have been successfully logged out.';

  return (
    <LogoPane>
      <Alert severity="success" Action={<AlertButton onClick={goToLogin}>Login Again</AlertButton>}>
        {message}
      </Alert>
    </LogoPane>
  );
}
